export default [
  {
    m: 'Hasta 250 m2',
    p: '$45.00 MXN'
  },
  {
    m: 'Hasta 400 m2',
    p: '$40.00 MXN'
  },
  {
    m: 'Hasta 700 m2',
    p: '$35.00 MXN'
  },
  {
    m: 'Hasta 1000 m2',
    p: '$33.00 MXN'
  },
  {
    m: 'Hasta 5000 m2',
    p: '$30.00 MXN'
  },
  {
    m: 'Hasta 7000 m2',
    p: '$28.00 MXN'
  },
  {
    m: 'Hasta 7000 m2 en adelante',
    p: '$28.00 MXN'
  },
]
